module.exports = __webpack_public_path__ + "media/logos/dzi-spendensiegel-c01f56e2.svg";